export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_SignUpSignIn"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://crsauth.b2clogin.com/crsauth.onmicrosoft.com/B2C_1_SignUpSignIn",
        }
    },
    authorityDomain: "crsauth.b2clogin.com"
};

export const Client = {
    ID: '56a2d622-900d-4a47-a424-f905a45172ec'
} 
